import eventManager from "../../store/sqftEventManager";
import config from "../../store/sqftConfig";
import workspace from "../workspace";
import store from "../../../../../../store";
import {setSQFTMenuOpened} from "../../../../../../actions/sqftMenuFunctions";
import {updateSQFTCalculations} from "../../../../../../actions/sqftFunctions";
import {attachResource} from "./resourseCanas";
import $ from "jquery";
import {iconPlusBlue} from "../../../../assetsSQFT";
import {RESOURCE_ATTACHED_TO_TYPE, SIDEBAR_NAVIGATION_CABINET_BUTTONS, SQFT_FEATURES} from "../../../../constants";
import {get3dURLsForFeature} from "../../../../helpers/sqft3dArHelper";

const crownMoldingCanvas = function() {
  this.cursorImage = null;
  this.addedImages = null; //like in edges
  this.img = null;
  this.isWaitingToRestoreCursor = false;

  this.setHighlighting = (disallowDemo) => {
    eventManager.stealCursor(true); // remove all other cursors
    workspace.setAllowEdges(false); //  removing sizing lines
    workspace.setAllowBumpoutEdges(false); //  removing bumpout lines
    config.highlight.points = false;	// remove radiuses
    config.highlight.lines = true;  // enable lines highlighting
    config.highlight.linesWithShapePartIds = [SQFT_FEATURES.upper_cabinet_boxes];  // enable lines highlighting

    if (!disallowDemo) {
      config.highlight.demoShow = true;
    }
    setTimeout(function () {
      config.highlight.demoShow = false;
    }, 1000);
  };

  this.setCursorImage = () => {
    let bounds = 18,
      imgWidth = bounds,
      imgHeight = bounds;

    let domImg = document.createElement('img');
    domImg.crossOrigin = "Anonymous";

    let $img = $(domImg);
    $img.css({
      position: 'absolute',
      width: '1px',
      height: '1px'
    });

    const imgOnLoad = () => {
      let bounds = 18;
      let ratio;
      if (imgWidth > imgHeight) {
        ratio = imgHeight / imgWidth;
        imgWidth = bounds;
        imgHeight = bounds * ratio;
      } else {
        ratio = imgWidth / imgHeight;
        imgHeight = bounds;
        imgWidth = bounds * ratio;
      }
      eventManager.setCursor('edge-select', this, true);
      this.cursorImage = { image: domImg, width: imgWidth, height: imgHeight };
      this.registerEvents(); // only after image is load!
    }
    $img.on('load', imgOnLoad);
    $img.appendTo($('body'));
    $img.attr('src', iconPlusBlue);

    this.img = $img;
  };

  this.registerEvents = () => {
    eventManager.setCursor('radius-select', this, true);
    eventManager.addEvent(
      eventManager.events.RENDER,
      this.renderCursor,
      this,
      eventManager.priorities.OVERALL
    );
    eventManager.addEvent(
      eventManager.events.MOUSE_UP,
      this.onMouseUp,
      this,
      eventManager.priorities.OVERALL
    );
  };

  this.deregisterEvents = () => {
    eventManager.resetCursor(this);
    eventManager.removeEvent(this);
    config.highlight.lines = false;
    config.highlight.linesWithShapePartIds = [];
  }

  this.destroy = (protect, revertBackAfterMouseUp) => {
    if (revertBackAfterMouseUp) {
      eventManager.removeEvent(this, eventManager.events.RENDER); //remove render only, but wait for mouse up to set cursor again
      this.isWaitingToRestoreCursor = true;
    } else {
      this.deregisterEvents();
    }
  };

  this.onMouseUp = (mousePos) => {
    void mousePos;
    let hoveredLine = workspace.getHoveredLine();
    let hoveredLineCorner = workspace.getHoveredLineCorner();
    if (hoveredLine && this.canBeAttached(hoveredLine)) {
      const state = store.getState();
      const updateCalculations = state.sqftState.updateCalculations;
      const selectedFeature = state.sqftResourceState.selectedFeature;
      const featureNameTranslated = selectedFeature.getFeatureName();

      if (hoveredLine || hoveredLineCorner) {
        attachResource(hoveredLine, hoveredLineCorner, RESOURCE_ATTACHED_TO_TYPE.crown_molding, selectedFeature.dbFeature.id, SQFT_FEATURES.crown_molding, featureNameTranslated);
        const URLByFeatureName = get3dURLsForFeature(selectedFeature);
        hoveredLine.setCrownMolding3dURL(URLByFeatureName);
        hoveredLine.setCrownMoldingFeatureId(selectedFeature.dbFeature.id);
      } else {
        store.dispatch(setSQFTMenuOpened(SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown_molding));
      }

      store.dispatch(updateSQFTCalculations(updateCalculations + 1));
    }

    this.checkForRestoreCursor();
  };

  this.canBeAttached = (line) => {
    const shape = line.getParent();
    return shape && shape.partId === SQFT_FEATURES.upper_cabinet_boxes;
  }

  this.checkForRestoreCursor = function() {
    if (this.isWaitingToRestoreCursor) {
      this.isWaitingToRestoreCursor = false;
      eventManager.removeEvent(this, eventManager.events.MOUSE_UP); //remove mouse up, it will be added in setCursorImage
      this.setHighlighting(true);
      this.setCursorImage();
    }
  };
  this.renderCursor = (ctx) => {
    if (this.cursorImage.image && ($(window).width() > 768)) {
      let mPos = eventManager.LastKnownMousePos;
      if (mPos) {
        ctx.drawImage(this.cursorImage.image, mPos.x + 10, mPos.y + 10, this.cursorImage.width, this.cursorImage.height);
      }
    }
  };
};

export default new crownMoldingCanvas();
